import { Stack } from '@mui/material';

import { useDialogConfirm } from '@/ui/components/confirm-dialog/useDialogConfirm';

export function DialogDemo() {
  const dialogConfirm = useDialogConfirm();

  return (
    <Stack sx={{ alignItems: 'start', gap: 2 }}>
      <button
        onClick={async () => {
          const response = await dialogConfirm({ description: DESCRIPTION });
          if (response === 'confirmed') {
            alert('confirmed');
          }
        }}
      >
        Open Confirm dialog (descripion only) (cancel / confirm)
      </button>
      <button
        onClick={async () => {
          const response = await dialogConfirm({
            title: 'Dialog title',
            description: DESCRIPTION,
          });
          if (response === 'confirmed') {
            alert('confirmed');
          }
        }}
      >
        Open Confirm dialog (title + description) (cancel / confirm)
      </button>
      <button
        onClick={async () => {
          const response = await dialogConfirm({
            description: 'Voulez vous supprimer le projet ?',
          });
          if (response === 'confirmed') {
            alert('confirmed');
          }
        }}
      >
        Open Confirm dialog (short description) (cancel / confirm)
      </button>
      <button
        onClick={async () => {
          const response = await dialogConfirm({
            title: 'Voulez vous supprimer le projet ?',
          });
          if (response === 'confirmed') {
            alert('confirmed');
          }
        }}
      >
        Open Confirm dialog (title only) (cancel / confirm)
      </button>
      <button
        onClick={async () => {
          const response = await dialogConfirm({
            title: 'Avec confirmation par checkbox',
            acknowledgement: 'acknowledgement',
          });
          if (response === 'confirmed') {
            alert('confirmed');
          }
        }}
      >
        Open Confirm dialog (with acknowledgement) (cancel / confirm)
      </button>
    </Stack>
  );
}

const DESCRIPTION =
  'lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
